import React, {useState, useEffect} from 'react';
import { Card }                     from 'react-bootstrap';
import { useNavigate }              from 'react-router-dom';
import GoalDetailsUpdateMG          from './GoalDetailsUpdateMG';
import GoalDetailsUpdateDC          from './GoalDetailsUpdateDC';
import GoalDetailsUpdateDQT         from './GoalDetailsUpdateDQT';
import GoalDetailsUpdateDXY_LT      from './GoalDetailsUpdateDXY_LT';
import GoalDetailsUpdateDXY_AL      from './GoalDetailsUpdateDXY_AL';
import GoalDetailsUpdateCL          from './GoalDetailsUpdateCL';
import GoalDetailsUpdateCD          from './GoalDetailsUpdateCD';
import GoalDetailsUpdateRM          from './GoalDetailsUpdateRM';
import { BsArrowLeftSquareFill }    from 'react-icons/bs';

function GoalDetailsUpdate( { selGoal, refresh } ) {
  const [goal, setGoal] = useState( { goal_type: 0 } );
  const navigate        = useNavigate();
  
  useEffect(() => {
    if (selGoal) {
        setGoal(selGoal);
    }
  }, [selGoal]); 

  const handleBack = () => {
        navigate('/status', {  });     
  };

  const requestRefresh = () => {
        refresh();
  };
  
  return(
      <Card>
      <Card.Header className="card-goal-header">
        <Card.Title>
          <div class="content-container">
            <div class="left-content d-flex align-items-center">
              Goal Details
            </div>
            <div class="right-content">
               <BsArrowLeftSquareFill onClick={() => handleBack()}/>
            </div>
          </div>
        </Card.Title>
        <Card.Subtitle className="text-center">{goal.goal_title}</Card.Subtitle>
        <Card.Subtitle className="text-center">{goal.goal_description}</Card.Subtitle>
      </Card.Header>
        <Card.Body className="p-0" >
        { goal.goal_type === 1 && ( <GoalDetailsUpdateMG     goal={ goal }  /> ) }    
        { goal.goal_type === 2 && ( <GoalDetailsUpdateDC     goal={ goal } /> ) }    
        { goal.goal_type === 3 && ( <GoalDetailsUpdateDQT    goal={ goal } /> ) }    
        { goal.goal_type === 4 && ( <GoalDetailsUpdateDXY_LT goal={ goal } /> ) }    
        { goal.goal_type === 5 && ( <GoalDetailsUpdateDXY_AL goal={ goal } /> ) }    
        { goal.goal_type === 6 && ( <GoalDetailsUpdateCL     selGoal={ goal } refresh={requestRefresh} /> ) }    
        { goal.goal_type === 7 && ( <GoalDetailsUpdateCD     goal={ goal } /> ) }    
        { goal.goal_type === 8 && ( <GoalDetailsUpdateRM     selGoal={ goal } refresh={requestRefresh} /> ) }    
        </Card.Body>
      </Card>
  );
}

export default GoalDetailsUpdate;
